export const MINIMALISTIC_PORTFOLIO_STYLESHEETS = [
  "/static/site/venuex/vorin/demos/minimalistic-portfolio/minimalistic-portfolio.css",
] as const;
